import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Icon } from '@/components/common/Icon';
import {
  useAssistantPulseQuery,
  useDismissAssistantHintMutation,
} from '@/hooks/useAssistantProactive';
import { useAssistantPanel } from './assistantPanelContext';
import { resolveAssistantPageContext } from './uiActions/assistantDestinations';

export function AssistantHintChip() {
  const { t } = useTranslation('assistant');
  const location = useLocation();
  const { isOpen, askAbout } = useAssistantPanel();
  const pulseQuery = useAssistantPulseQuery();
  const dismissMutation = useDismissAssistantHintMutation();
  const pulse = pulseQuery.data;
  if (pulse === undefined || pulse.isActive === false || isOpen) {
    return null;
  }
  const routeKey = resolveAssistantPageContext(location.pathname, location.search).routeKey;
  const hint = pulse.hints.find(function isForThisScreen(candidate) {
    return candidate.destination === routeKey;
  });
  if (hint === undefined) {
    return null;
  }
  return (
    <div
      role="status"
      className="flex items-center gap-1 h-9 pl-3 pr-1 rounded-full border border-zooborder bg-zoovpalelavender text-sm text-zooindigo shadow-sm"
    >
      <button
        type="button"
        onClick={function askAboutHint() {
          askAbout(
            t('destinations.' + hint.destination, { defaultValue: t('destinations.fallback') }),
            t('hints.' + hint.key + '.question')
          );
        }}
        className="flex items-center gap-1.5 font-medium hover:text-zooprimary focus:outline-none focus-visible:ring-2 focus-visible:ring-zooprimary rounded-full"
      >
        <Icon name="Sparkles" className="text-zooprimary" />
        {t('hints.' + hint.key + '.chip')}
      </button>
      <button
        type="button"
        aria-label={t('hints.dismiss')}
        title={t('hints.dismiss')}
        disabled={dismissMutation.isPending}
        onClick={function dismissHint() {
          dismissMutation.mutate(hint.key);
        }}
        className="w-7 h-7 rounded-full flex items-center justify-center text-zoomuted hover:bg-zoowhite hover:text-zooindigo focus:outline-none focus-visible:ring-2 focus-visible:ring-zooprimary"
      >
        <Icon name="X" />
      </button>
    </div>
  );
}
